var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGemini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-b5c009b6-294a-48fa-8c1d-c1c1fc78c122",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-3c083e88-6106-4912-957c-0cdd55a9c848 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-3c083e88-6106-4912-957c-0cdd55a9c848",
    d: "M23.5,16.01c-4.03.25-7.24,3.46-7.49,7.49h-.03c-.25-4.03-3.46-7.24-7.48-7.49v-.03c4.03-.25,7.24-3.46,7.49-7.48h.03c.25,4.03,3.46,7.24,7.49,7.49v.03Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemini);
export default __webpack_public_path__ + "static/media/Gemini.1de2e1d1f1a9c8051981c85ad5d2956e.svg";
export { ForwardRef as ReactComponent };